import {
    postFindInsuranceCompanyInformation,
    postCreateInsuranceCompanyInformation,
    postUploadNewInsuranceCompanyInformationFile,
    postUploadExistInsuranceCompanyInformationFile,
    putInsuranceCompanyInformation,
    deleteInsuranceCompanyInformation
} from './api/insurancecompanyinformation'

class InsuranceCompanyInformationDataService {
    async findByCondition(_insurance_company_id, _page, _itemsPerPage){
        try{
            const result = await postFindInsuranceCompanyInformation(_insurance_company_id, _page, _itemsPerPage)
            return result
        } catch (err) {
            return err
        } 
    }

    async createInformation(_insurance_company_id, _title, _link, _description, _publish_date){
        var params = {
            insurance_company_information: {
                insurance_company_id: _insurance_company_id,
                title: _title,
                link: _link,
                description: _description,
                publish_date: _publish_date
            }
        }
        try {
            const result = await postCreateInsuranceCompanyInformation(params)
            return result
        } catch (err) {
            return err
        } 
    }

    async uploadNewInformationFile(_insurance_company_id, _title, _description, _publish_date, _file){
        try {
            const result = await postUploadNewInsuranceCompanyInformationFile(_insurance_company_id, _title, _description, _publish_date, _file)
            return result
        } catch (err) {
            return err
        } 
    }

    async uploadExistInformationFile(_id, _insurance_company_id, _title, _description, _publish_date, _file){
        try {
            const result = await postUploadExistInsuranceCompanyInformationFile(_id, _insurance_company_id, _title, _description, _publish_date, _file)
            return result
        } catch (err) {
            return err
        } 
    }

    async updateInformation(_id, _title, _link, _description, _publish_date){
        var params = {
            insurance_company_information: {
                title: _title,
                link: _link,
                description: _description,
                publish_date: _publish_date
            }
        }
        try {
            const result = await putInsuranceCompanyInformation(_id, params)
            return result
        } catch (err) {
            return err
        } 
    }

    async deleteInformation(_id){
        try {
            console.log(_id, 'deleteInsuranceCompanyInformation, id')
            const result = await deleteInsuranceCompanyInformation(_id)
            return result
        } catch (err) {
            return err
        } 
    }
}

export default new InsuranceCompanyInformationDataService()